import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const pencil: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="m2.844 0 .703-.719-1.828-1.828L1-1.844V-1h1v1Zm4.078-7.25q-.001-.17-.172-.172a.17.17 0 0 0-.125.047L2.391-3.141A.2.2 0 0 0 2.328-3q-.002.174.172.172.076 0 .14-.063l4.235-4.234a.17.17 0 0 0 .047-.125M6.5-8.75 9.75-5.5 3.25 1H0v-3.25zm5.344.75a.96.96 0 0 1-.297.703L10.25-6 7-9.25l1.297-1.297A.94.94 0 0 1 9-10.844c.281 0 .52.102.719.297l1.828 1.828c.195.211.297.45.297.719m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 10.844)"
    />
  ),
  svgProps: {
    height: "11.844",
    width: "11.844",
  }
};

export const pencilSquareOutline: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="m6.938-2.75.906-.906-1.188-1.188-.906.907v.437h.75v.75zm3.437-5.375q.123-.122 0-.25-.128-.123-.25 0L7.391-5.641q-.143.142-.016.266.124.127.266-.016zM11-3.735v1.485q0 .925-.656 1.594A2.17 2.17 0 0 1 8.75 0h-6.5A2.2 2.2 0 0 1 .656-.656 2.2 2.2 0 0 1 0-2.25v-6.5q0-.937.656-1.594A2.2 2.2 0 0 1 2.25-11h6.5q.498 0 .922.188.105.064.14.187a.26.26 0 0 1-.078.219l-.375.39q-.11.111-.25.063A1.5 1.5 0 0 0 8.75-10h-6.5q-.515 0-.89.375c-.243.242-.36.531-.36.875v6.5c0 .344.117.64.36.89.25.243.546.36.89.36h6.5c.344 0 .633-.117.875-.36Q10-1.733 10-2.25v-.984c0-.07.023-.13.078-.172l.5-.5q.106-.122.266-.063a.24.24 0 0 1 .156.235M10.25-9.5l2.25 2.25L7.25-2H5v-2.25Zm3.469 1.031L13-7.75 10.75-10l.719-.719a.72.72 0 0 1 .531-.218q.31.001.531.218L13.72-9.53a.74.74 0 0 1 .219.531q-.001.316-.22.531m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 11)"
    />
  ),
  svgProps: {
    height: "11",
    width: "13.938",
  }
};
